import React, { useEffect, useState } from "react";
import { CalendarDaysIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { DayPicker, getDefaultClassNames } from "react-day-picker";
import "react-day-picker/style.css";
import { formatAppDate } from "../../helpers/date-formatter";

function SearchView(props) {
  const { onSearch, search, start, end } = props;

  const [showDatePicker, setShowDatePicker] = useState(false);
  const [date, setDate] = useState(null);
  const [searchText, setSearchText] = useState(search ?? "");

  const defaultClassNames = getDefaultClassNames();

  useEffect(() => {
    setSearchText(search);
  }, [search]);

  useEffect(() => {
    if (start != null && end != null) {
      setDate({
        from: start,
        to: end,
      });
    }
  }, [start, end]);

  const toggleDatePickerView = () => {
    setShowDatePicker((prev) => !prev);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    handleSearch();
  };

  const handleSearch = () => {
    setShowDatePicker(false);
    onSearch(searchText, date?.from ?? null, date?.to ?? null);
  };

  return (
    <div className="w-full h-auto p-4 relative">
      <form className="w-full h-full" onSubmit={handleFormSubmit}>
        <div className="flex flex-row justify-end items-center gap-4">
          <input
            type="text"
            placeholder="Search..."
            className="h-10 py-2 px-3 w-80 rounded border-[1px] border-neutral"
            value={searchText}
            onChange={(e) => setSearchText(e.currentTarget.value)}
          />

          {date == null ? (
            <div
              className="w-8 h-8 text-primary cursor-pointer hover:text-primary-light"
              onClick={toggleDatePickerView}
            >
              <CalendarDaysIcon className="w-full h-full" />
            </div>
          ) : (
            <div
              className="text-white bg-gray-700 rounded-lg px-4 py-2 flex flex-row gap-2 font-medium cursor-pointer hover:bg-gray-600"
              onClick={toggleDatePickerView}
            >
              <span>{formatAppDate(date.from)}</span>
              <span>-</span>
              <span>{formatAppDate(date.to)}</span>
            </div>
          )}

          <button
            type="button"
            className="text-white bg-primary px-5 h-10 rounded-lg hover:bg-primary-light"
            onClick={handleSearch}
          >
            Search
          </button>
        </div>
      </form>
      {showDatePicker && (
        <div className="absolute right-0 w-auto flex flex-col justify-end gap-4 h-auto bg-gray-700 p-4 mt-5 text-white">
          <div className="flex justify-end text-white hover:text-gray-300">
            <XMarkIcon
              className="w-6 h-6 cursor-pointer"
              onClick={toggleDatePickerView}
            />
          </div>
          <DayPicker
            animate
            mode="range"
            numberOfMonths={2}
            endMonth={new Date()}
            selected={date}
            onSelect={setDate}
            classNames={{
              root: `${defaultClassNames.root}`,
              nav_button: "text-white hover:text-icon-green fill-white",
              chevron: "fill-white",
              selected: `bg-primary text-white`,
              range_start: `bg-primary text-white`,
              range_middle: `bg-primary text-white`,
              range_end: `bg-primary text-white`,
              today: `text-icon-green font-bold`,
            }}
          />
        </div>
      )}
    </div>
  );
}

export default SearchView;
